<template>
    <Modal :visible="visible" :aria-labelledby="titleId" @close="closeModal">
        <div
            class="d-flex flex-column align-items-center justify-content-center"
        >
            <i
                class="fi fi-lg mb-2"
                style="font-size: 34px; line-height: 34px"
                :class="icon"
                aria-hidden="true"
            ></i>
            <h2 :id="titleId" class="my-1 text-center">{{ title }}</h2>
            <div
                class="mt-2 text-center mb-3 w-100"
                style="color: var(--neutral-800)"
            >
                <slot></slot>
            </div>
            <div>
                <button
                    type="button"
                    :class="cancelButtonClass"
                    @click="closeModal"
                >
                    {{ resolvedCancelButtonText }}
                </button>
                <button
                    type="button"
                    :class="confirmButtonClass"
                    :disabled="confirmDisabled"
                    @click="confirmAction"
                >
                    {{ resolvedConfirmButtonText }}
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

let confirmModalId = 0;

export default {
    name: 'ConfirmModal',
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: 'Confirm?',
        },
        confirmButtonText: {
            type: String,
            default: null,
        },
        cancelButtonText: {
            type: String,
            default: null,
        },
        cancelButtonClass: {
            type: String,
            default: 'btn btn-desktop-lg btn-white me-2',
        },
        confirmButtonClass: {
            type: String,
            default: 'btn btn-desktop-lg btn-primary',
        },
        visible: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
            default: 'fi-alert-circle text-danger',
        },
        confirmDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
    data() {
        return {
            titleId: `confirm-modal-title-${++confirmModalId}`,
        };
    },
    computed: {
        resolvedConfirmButtonText() {
            return this.confirmButtonText || this.$t('common.actions.confirm');
        },
        resolvedCancelButtonText() {
            return this.cancelButtonText || this.$t('common.actions.no');
        },
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        confirmAction() {
            this.$emit('confirm');
        },
    },
};
</script>
